import { Injectable, isDevMode } from '@angular/core';

import { CookieService } from './cookie.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private loggedIn = false;
  constructor(private cookieService: CookieService) {
    this.setupAuthToken();
    this.loggedIn = !!this.getAuthToken();
  }

  setupAuthToken() {
    const cookieToken = this.cookieService.getAuthTokenFromCookie();
    this.setAuthToken(cookieToken || '');
  }

  getAuthToken(): string {
    if (isDevMode()) {
      return 'true';
    }
    return sessionStorage.getItem('auth_token');
  }

  setAuthToken(token: string): void {
    return sessionStorage.setItem('auth_token', token);
  }

  isLoggedIn() {
    return this.loggedIn;
  }
}
